import {
  Period,
  Details,
  Detail,
  Location,
  DateTime,
  NoDates,
  WithDates,
  ChoosePeriod,
  Placeholder
} from './styles'

Period.Details = Details
Period.Detail = Detail
Period.Location = Location
Period.DateTime = DateTime
Period.NoDates = NoDates
Period.WithDates = WithDates
Period.ChoosePeriod = ChoosePeriod
Period.Placeholder = Placeholder

export default Period
